import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Card,
  Grid,
  InputLabel,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Typography,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import {
  abhaSearchThunk,
  abhaAddOtpThunk,
  abhaVerifyOtpThunk,
} from "./reducer/thunk.js";
import Methods from "../../utility/Methods.js";
import Colors from "../../utility/Colors.js";
import OtpVerification from "../../components/otpVerification/otpVerification.js";
import { useNavigate } from "react-router-dom";
import { getSession, setLoginDetails } from "../../utility/SessionManager.js";
import constants from "../../common/constants.js";
import { Box } from "@mui/system";
import OtpInput from "react-otp-input";
import BackdropComponent from "../../components/backdrop/index.tsx";
import {
  resetAbhaSearch,
  resetAbhaAddOtp,
  resetVerifyOtp,
  resetAbhaVerifyOtp,
} from "./reducer/slice.js";

const AbhaAddressLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOTP, setShowOTP] = useState(false);
  const [abhaAddress, setabhaAddress] = useState("");
  const [OTP, setOTP] = useState("");
  const [txnId, setTxnId] = useState("");
  const [message, setMessage] = useState("");
  const [authArray, setAuthArray] = useState([]);
  const [showAbhaProfile, setShowAbhaProfile] = useState(false);
  const [abhaCardArray, setAbhaCardArray] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [authType, setAuthType] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const abhaAddOtp = useSelector((state) => state.login.abhaAddOtp);
  const {
    status: abhaAddOtpStatus,
    data: abhaAddOtpData,
    error: abhaAddOtpError,
  } = abhaAddOtp;
  const abhaVerifyOtp = useSelector((state) => state.login.abhaVerifyOtp);
  const {
    status: abhaVerifyOtpStatus,
    data: abhaVerifyOtpData,
    error: abhaVerifyOtpError,
  } = abhaVerifyOtp;
  const { loading } = useSelector((state) => state.auth);
  const abhaSearch = useSelector((state) => state.login.abhaSearch);
  const {
    status: abhaSearchStatus,
    data: abhaSearchData,
    error: abhaSearchError,
  } = abhaSearch;
  useEffect(() => {
    if (abhaAddOtpStatus === "succeeded") {
      console.log("enc res", abhaAddOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(abhaAddOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(abhaAddOtpData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.txnId);
      setMessage(finalData?.message);
      setShowOTP(true);
      setShowAbhaProfile(false);

      handleShowSnackbar("success", "OTP sent successfully!");
    } else if (abhaAddOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(abhaAddOtpError));
      // console.log("abhaVerifyOtp data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [abhaAddOtpStatus]);

  useEffect(() => {
    if (abhaSearchStatus === "succeeded") {
      console.log("enc res", abhaSearchData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(abhaSearchData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(abhaSearchData?.data));
      console.log("abhaSearchData ", decData.response);
      let finalData = decData.response;
      // setTxnId(finalData?.[0]?.txnId);
      setMessage(finalData?.message);
      setShowAbhaProfile(true);
      setAuthArray(finalData?.authMethods);

      handleShowSnackbar("success", "Abha Search completed!");
    } else if (abhaSearchStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(abhaSearchError));
      console.log("verifyAbhaSearch data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [abhaSearchStatus]);

  useEffect(() => {
    if (abhaVerifyOtpStatus === "succeeded") {
      console.log("enc res", abhaVerifyOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(abhaVerifyOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(abhaVerifyOtpData?.data));
      console.log("abhaVerifyOtp data", decData.response);
      let finalData = decData.response;
      if (finalData?.authResult === "failed") {
        handleShowSnackbar("error", finalData?.message);
      } else {
        setLoginDetails(finalData);
        setShowOTP(false);
        setShowAbhaProfile(false);
        navigate(constants.PATH_DASHBOARD, {
          state: { source: "abhaAddress" },
        });

        handleShowSnackbar("success", "OTP verified successfully!");
      }
    } else if (abhaVerifyOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(abhaVerifyOtpError));
      console.log("abhaVerifyOtp data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [abhaVerifyOtpStatus]);

  useEffect(() => {
    if (getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)) {
      navigate(constants.PATH_DASHBOARD, {
        state: { source: "abhaAddress" },
      });
    }
  }, [navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
    //!to reset next button redirection functionality
    return () => {
      dispatch(resetAbhaAddOtp());
      dispatch(resetAbhaSearch());
    };
  }, []);

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity,
      message,
    });
  };

  const handleSnackClose = () => {
    setSnackbarOpen({
      open: false,
      severity: "",
      message: "",
    });
  };

  const validationSchema = Yup.object({
    abhaAddress: Yup.string()
      .matches(/^[a-zA-Z0-9._%+-]+@(abdm|sbx)$/, "Enter a valid ABHA Address")
      .required("ABHA Address is required"),
  });
  const handleSubmitData = async (data) => {
    let finalAbha = data?.abhaAddress;
    setabhaAddress(finalAbha);
    const reqObj = {
      abhaAddress: data?.abhaAddress,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log("decrypted object", Methods.decryptObject(finalReqObj));

    dispatch(abhaSearchThunk(finalReqObj));
  };

  const handleSendOtp = async (data) => {
    const reqObj = {
      loginId: abhaAddress || "",
      loginHint: "abha-address",
      scope: authType,
      txnId: "",
    };

    let finalReqObj = Methods.encryptObject(reqObj);
    console.log("decrypted object", Methods.decryptObject(finalReqObj));

    dispatch(abhaAddOtpThunk(finalReqObj));
  };

  const handleVerifyOtp = (otp) => {
    setOTP(otp);
    let reqObj = {
      txnId: txnId,
      otp: otp,
      scope: authType,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object verify otp",
      Methods.decryptObject(finalReqObj)
    );
    dispatch(abhaVerifyOtpThunk(finalReqObj));
  };

  const handleResendOtp = () => {
    const reqObj = {
      loginId: abhaAddress || "",
      loginHint: "abha-address",
      scope: authType,
      txnId: txnId,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    dispatch(abhaAddOtpThunk(finalReqObj));
  };

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {abhaAddOtpStatus === "pending" && <BackdropComponent />}
        {abhaVerifyOtpStatus === "pending" && <BackdropComponent />}
        {abhaSearchStatus === "pending" && <BackdropComponent />}
        {!showOTP && !showAbhaProfile ? (
          <Formik
            initialValues={{ abhaAddress: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSubmitData(values);
            }}
          >
            {(props) => (
              <Form>
                <Grid container spacing={4} sx={{ p: 1 }}>
                  {[
                    {
                      name: "abhaAddress",
                      label: "ABHA Address",
                      type: "input",
                      required: true,
                    },
                  ].map((field) => (
                    <>
                      {field?.type === "input" ? (
                        <Grid item size={{ xs: 12, md: 6 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <>
                                <InputLabel
                                  htmlFor={field.label}
                                  sx={{ mb: 2 }}
                                >
                                  Enter ABHA Address
                                </InputLabel>

                                <TextField
                                  {...formikField}
                                  variant="outlined"
                                  size="medium"
                                  label={field.label}
                                  required={field?.required}
                                  type={
                                    field.type === "checkbox"
                                      ? "checkbox"
                                      : "text"
                                  }
                                  fullWidth
                                  autoFocus={true}
                                  error={meta.touched && Boolean(meta.error)}
                                  helperText={meta.touched && meta.error}
                                  // InputProps={{
                                  //   endAdornment: (
                                  //     <InputAdornment position="end">
                                  //       <Box
                                  //       sx={{
                                  //         backgroundColor: "#f2f2f2",
                                  //         px: 2,
                                  //         height: "100%", // Full height of input
                                  //         display: "flex",
                                  //         alignItems: "center", // Center text vertically
                                  //         borderRadius: "0 4px 4px 0", // Match TextField rounded corners
                                  //       }}
                                  //       >
                                  //         @sbx
                                  //       </Box>
                                  //     </InputAdornment>
                                  //   ),
                                  // }}
                                />
                              </>
                            )}
                          </Field>
                        </Grid>
                      ) : null}
                    </>
                  ))}
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{ p: 1 }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    sx={{
                      cursor: "pointer",
                      background:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : "rgb(245, 132, 31)",
                      color:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : Colors.WHITE,
                      px: 6,
                      my: 5,
                      borderRadius: "5px",
                      "&:hover": { opacity: 0.9 },
                    }}
                    type="submit"
                    disabled={!(props.isValid && props.dirty)}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Next"
                    )}
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        ) : showOTP ? (
          <OtpVerification
            onVerify={handleVerifyOtp}
            onResend={handleResendOtp}
            message={message}
          />
        ) : showAbhaProfile ? (
          <>
            <Grid container>
              <Grid item size={{ xs: 12, md: 6 }}>
                <Typography className="cc_tc_title">
                  Authentication type <span style={{ color: "#f00" }}>*</span>
                </Typography>
                <Box className="nh_search_select">
                  <Select
                    displayEmpty
                    value={authType}
                    input={<OutlinedInput />}
                    inputProps={{ "aria-label": "Without label" }}
                    className="nh_tpa_btn fs-16-600"
                    SelectDisplayProps={{
                      style: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                    }}
                    sx={{
                      marginTop: ".5rem",
                    }}
                    fullWidth
                    onChange={(e) => setAuthType(e.target.value)}
                  >
                    {authArray?.includes("AADHAAR_OTP") && (
                      <MenuItem value={"aadhaar-verify"}>Aadhaar OTP</MenuItem>
                    )}
                    {authArray?.includes("MOBILE_OTP") && (
                      <MenuItem value={"mobile-verify"}>Mobile OTP</MenuItem>
                    )}
                    {!authArray && (
                      <MenuItem value={"mobile-verify"}>Mobile OTP</MenuItem>
                    )}
                  </Select>
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{ p: 1 }}
              justifyContent="center"
              alignItems="center"
            >
              <Button
                sx={{
                  cursor: "pointer",
                  background: authType ? "rgb(245, 132, 31)" : "#b3b3b3",
                  color: authType ? Colors.WHITE : "#b3b3b3",

                  px: 6,
                  my: 5,
                  borderRadius: "5px",
                  "&:hover": { opacity: 0.9 },
                }}
                onClick={handleSendOtp}
                disabled={!authType}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Next"
                )}
              </Button>
            </Grid>
          </>
        ) : null}

        <SnackbarComponent
          message={snackbarOpen?.message}
          isOpen={snackbarOpen?.open}
          purpose={snackbarOpen?.severity}
          handleClick={handleSnackClose}
        />
      </Card>
    </div>
  );
};

export default AbhaAddressLogin;
